import { render, staticRenderFns } from "./prioritization-configuration-selector.vue?vue&type=template&id=5b9f8e19&"
import script from "./prioritization-configuration-selector.vue?vue&type=script&lang=js&"
export * from "./prioritization-configuration-selector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports